/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import GenericToggleButtons from "../../components/GenericToggleButtons";
import { useSelector } from "react-redux";
import { selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";

const ResourceStatusRadioButton = ({ foi, setJsonViewEditingState, setStatusChanged }) => {
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const pubStatus = parentResourceDetail?.permissionData?.status;
    const adminPermission = parentResourceDetail?.permissionData?.adminpermission;

    let values = ["active", "draft"];
    let labels = ["Publish (anyone can view)", "Draft (only editors can view)"];

    if (adminPermission) {
        values.push("retired");
        labels.push("Retired");
    }

    const [fhirEntryState, setFhirEntryState] = useState({ "status": pubStatus });

    useEffect(() => {
        if (fhirEntryState.status && pubStatus && fhirEntryState.status !== pubStatus) {
            setStatusChanged(true);
            setJsonViewEditingState(prevState => {
                return {
                    ...prevState,
                    "status": fhirEntryState.status
                }
            });
        }
    }, [fhirEntryState]);

    return <>
        <GenericToggleButtons thin={true} boxes={true} togglable={false}
            values={values}
            labels={labels}
            fieldLabel="status" elementName="status"
            startingValue={fhirEntryState.status} setter={setFhirEntryState}
        />
        <br />
        <br />
    </>
}

export default ResourceStatusRadioButton;